<template>
  <div class="loginWrapper">
    <div v-if="step === 1" class="step-1">
      <div class="login-input-control">
        <input class="fullWidth" v-model="email" type="email" :placeholder="$t('אימייל')">
      </div>
      <div class="login-password-wrapper mt-half">
        <input v-model="password" type="password" :placeholder="$t('סיסמה')">
        <button type="button" @click="login" class="login-btn">
          <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="23.0234" cy="23.4309" r="22.5" fill="white"/>
            <path d="M26.0234 16.4309C26.156 16.4309 26.2832 16.4836 26.377 16.5774C26.4708 16.6711 26.5234 16.7983 26.5234 16.9309C26.5234 17.0635 26.4708 17.1907 26.377 17.2845C26.2832 17.3782 26.156 17.4309 26.0234 17.4309L19.5234 17.4309C18.993 17.4309 18.4843 17.6416 18.1092 18.0167C17.7342 18.3918 17.5234 18.9005 17.5234 19.4309L17.5234 27.4309C17.5234 27.9613 17.7342 28.4701 18.1092 28.8451C18.4843 29.2202 18.993 29.4309 19.5234 29.4309L26.0234 29.4309C26.156 29.4309 26.2832 29.4836 26.377 29.5774C26.4708 29.6711 26.5234 29.7983 26.5234 29.9309C26.5234 30.0635 26.4708 30.1907 26.377 30.2845C26.2832 30.3782 26.156 30.4309 26.0234 30.4309L19.5234 30.4309C18.7278 30.4309 17.9647 30.1148 17.4021 29.5522C16.8395 28.9896 16.5234 28.2266 16.5234 27.4309L16.5234 19.4309C16.5234 18.6353 16.8395 17.8722 17.4021 17.3096C17.9647 16.747 18.7278 16.4309 19.5234 16.4309L26.0234 16.4309ZM25.8774 27.2849C25.831 27.3315 25.7758 27.3684 25.7151 27.3936C25.6543 27.4188 25.5892 27.4318 25.5234 27.4318C25.4577 27.4318 25.3925 27.4188 25.3318 27.3936C25.2711 27.3684 25.2159 27.3315 25.1694 27.2849L21.6694 23.7849C21.6229 23.7385 21.5859 23.6833 21.5607 23.6225C21.5355 23.5618 21.5225 23.4967 21.5225 23.4309C21.5225 23.3651 21.5355 23.3 21.5607 23.2393C21.5859 23.1785 21.6229 23.1234 21.6694 23.0769L25.1694 19.5769C25.2633 19.483 25.3907 19.4303 25.5234 19.4303C25.6562 19.4303 25.7835 19.483 25.8774 19.5769C25.9713 19.6708 26.0241 19.7981 26.0241 19.9309C26.0241 20.0637 25.9713 20.191 25.8774 20.2849L23.2304 22.9309L32.0234 22.9309C32.156 22.9309 32.2832 22.9836 32.377 23.0774C32.4708 23.1711 32.5234 23.2983 32.5234 23.4309C32.5234 23.5635 32.4708 23.6907 32.377 23.7845C32.2832 23.8782 32.156 23.9309 32.0234 23.9309L23.2304 23.9309L25.8774 26.5769C25.924 26.6234 25.9609 26.6785 25.9861 26.7393C26.0114 26.8 26.0243 26.8651 26.0243 26.9309C26.0243 26.9967 26.0114 27.0618 25.9861 27.1225C25.9609 27.1833 25.924 27.2385 25.8774 27.2849Z" />
          </svg>
        </button>
      </div>
      <div class="more-login-actions text-align-right flex align-center mt-half">
        <olyo-checkbox
            v-model="rememberMe"
        >
          <span>{{ $t('זכור אותי') }}</span>
        </olyo-checkbox>
        <button @click="showRegisterModal" class="register-btn">
          {{ $t('הרשמה') }}
        </button>
      </div>
    </div>
    <div v-else-if="step === 2" class="step-2">
      <div class="login-otp-control">
        <input class="fullWidth" v-model="otp" type="tel" :placeholder="$t('קוד אימות')" />
        <button type="button" @click="checkOtp" class="login-btn">
          <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="23.0234" cy="23.4309" r="22.5" fill="white"/>
            <path d="M26.0234 16.4309C26.156 16.4309 26.2832 16.4836 26.377 16.5774C26.4708 16.6711 26.5234 16.7983 26.5234 16.9309C26.5234 17.0635 26.4708 17.1907 26.377 17.2845C26.2832 17.3782 26.156 17.4309 26.0234 17.4309L19.5234 17.4309C18.993 17.4309 18.4843 17.6416 18.1092 18.0167C17.7342 18.3918 17.5234 18.9005 17.5234 19.4309L17.5234 27.4309C17.5234 27.9613 17.7342 28.4701 18.1092 28.8451C18.4843 29.2202 18.993 29.4309 19.5234 29.4309L26.0234 29.4309C26.156 29.4309 26.2832 29.4836 26.377 29.5774C26.4708 29.6711 26.5234 29.7983 26.5234 29.9309C26.5234 30.0635 26.4708 30.1907 26.377 30.2845C26.2832 30.3782 26.156 30.4309 26.0234 30.4309L19.5234 30.4309C18.7278 30.4309 17.9647 30.1148 17.4021 29.5522C16.8395 28.9896 16.5234 28.2266 16.5234 27.4309L16.5234 19.4309C16.5234 18.6353 16.8395 17.8722 17.4021 17.3096C17.9647 16.747 18.7278 16.4309 19.5234 16.4309L26.0234 16.4309ZM25.8774 27.2849C25.831 27.3315 25.7758 27.3684 25.7151 27.3936C25.6543 27.4188 25.5892 27.4318 25.5234 27.4318C25.4577 27.4318 25.3925 27.4188 25.3318 27.3936C25.2711 27.3684 25.2159 27.3315 25.1694 27.2849L21.6694 23.7849C21.6229 23.7385 21.5859 23.6833 21.5607 23.6225C21.5355 23.5618 21.5225 23.4967 21.5225 23.4309C21.5225 23.3651 21.5355 23.3 21.5607 23.2393C21.5859 23.1785 21.6229 23.1234 21.6694 23.0769L25.1694 19.5769C25.2633 19.483 25.3907 19.4303 25.5234 19.4303C25.6562 19.4303 25.7835 19.483 25.8774 19.5769C25.9713 19.6708 26.0241 19.7981 26.0241 19.9309C26.0241 20.0637 25.9713 20.191 25.8774 20.2849L23.2304 22.9309L32.0234 22.9309C32.156 22.9309 32.2832 22.9836 32.377 23.0774C32.4708 23.1711 32.5234 23.2983 32.5234 23.4309C32.5234 23.5635 32.4708 23.6907 32.377 23.7845C32.2832 23.8782 32.156 23.9309 32.0234 23.9309L23.2304 23.9309L25.8774 26.5769C25.924 26.6234 25.9609 26.6785 25.9861 26.7393C26.0114 26.8 26.0243 26.8651 26.0243 26.9309C26.0243 26.9967 26.0114 27.0618 25.9861 27.1225C25.9609 27.1833 25.924 27.2385 25.8774 27.2849Z" />
          </svg>
        </button>
      </div>
      <div class="otp-message">
        {{otpMessage}}
      </div>
    </div>
  </div>

  <!-- Register Modal -->
  <RegisterModal v-if="isRegisterModalVisible" @close="closeRegisterModal"/>
</template>

<script>
import RegisterModal from "@/components/RegisterModal.vue"
import OlyoCheckbox from "@/components/buttons/OlyoCheckbox.vue";
import http from "@/http";

export default {
  components: {
    OlyoCheckbox,
    RegisterModal
  },
  data() {
    return {
      email: '',
      password: '',
      rememberMe: false,
      isRegisterModalVisible: false,
      otp: '',
      userId: '',
      step: 1,
      otpMessage: 'רישמו קוד מאפלקציית האימות שלכם',
      token: null,
      user: null
    };
  },
  computed: {
    isEmailValid() {
      const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return pattern.test(this.email);
    }
  },
  methods: {
    async login() {
      if (this.email && this.isEmailValid && this.password) {
        console.log("Email:", this.email, "Password:", this.password, "Remember Me:", this.rememberMe);
        // Typically, send the email, password, and rememberMe flag to your backend for authentication.
      } else if (!this.isEmailValid) {
        console.error("Invalid email format!");
      } else {
        console.error("Both email and password fields are required!");
      }

      try {
        const { data } = await http.post('auth/login', {
          email: this.email,
          password: this.password
        })
        if(data){
          if(data.check_otp && data.id){
            this.step = 2;
            this.userId = data.id
            if(data.is_email){
              this.otpMessage = 'רישמו קוד אימות שנשלח למייל שלכם'
            }
          }
        }
      }catch (e){
        console.log(e)
      }
    },
    async checkOtp(){
      if(this.token && this.user){
        const newTab = window.open(process.env.VUE_APP_BACKOFFICE_URL, '_blank');
        setTimeout(() => {
          newTab.postMessage({
            type: 'AUTH_TOKEN',
            token: this.token,
            user: this.user,
            siteId: window.siteId
          }, process.env.VUE_APP_BACKOFFICE_URL);
        }, 1000)
      }else{
        try {
          const { data } = await http.post('auth/check-otp', {
            otp: this.otp,
            user_id: this.userId
          })
          if(data && data.token){
            this.user = data.user;
            this.token = data.token;
            const newTab = window.open(process.env.VUE_APP_BACKOFFICE_URL, '_blank');
            setTimeout(() => {
              // Wait for the tab to load before sending the message
              newTab.postMessage({
                type: 'AUTH_TOKEN',
                token: data.token,
                user: data.user,
                siteId: window.siteId
              }, process.env.VUE_APP_BACKOFFICE_URL);
            }, 1000);
          }
        }catch (e){
          console.log(e)
        }
      }
    },
    showRegisterModal() {
      this.isRegisterModalVisible = true;
    },
    closeRegisterModal() {
      this.isRegisterModalVisible = false;
    }
  }
};
</script>

<style scoped lang="scss">
.loginWrapper {
  .login-input-control,
  .login-otp-control {
    margin-bottom: 10px;
  }

  .login-otp-control {
    display: flex;
    gap: 10px;
  }

  .login-password-wrapper {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  input {
    border-radius: 6.25rem;
    border: 1px solid #FFF;
    height: 45px;
    background-color: var(--primary) !important;
    color: #FFF;
    padding-inline: .8rem;
    min-width: 140px;
    flex-grow: 1;
    direction: ltr;

    &:is(:-webkit-autofill, :autofill) {
      background-color: var(--primary) !important;
      color: #FFF;
    }
  }

  .rememberMe {
    font-size: .8rem;

    input {
      display: none;
    }
  }
}

.more-login-actions {
  display: flex;
  justify-content: space-between;
}

.register-btn {
  background: transparent;
  border: 1px solid #FFF;
  border-radius: 6.25rem;
  padding: 0 1rem;
  color: #FFF;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
}

.login-btn {
  background-image: none;
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  svg path {
    fill: var(--primary);
  }
}
</style>
  